document.addEventListener('DOMContentLoaded', function () {

  const addButton = document.querySelector('button[name="add"]');

  if (!addButton) return;


  addButton.addEventListener('click', async function (event) {

    const quantityBreaks = document.querySelector('quantity-breaks');

    if (!quantityBreaks) return;


    const selects = quantityBreaks.querySelectorAll(
      '.quantity-break__variant-select'
    );


    if (!selects.length) return;


    event.preventDefault();


    const variantsScript = quantityBreaks.querySelector(
      'script[data-has-variants]'
    );


    if (!variantsScript) return;


    const variants = JSON.parse(
      variantsScript.textContent
    );


    let items = [];


    selects.forEach(select => {

      const color = select.value;


      const variant = variants.find(v => {

        return (
          v.option1 === color ||
          v.option2 === color ||
          v.option3 === color
        );

      });


      if (variant) {

        items.push({

          id: variant.id,

          quantity: 1

        });

      }

    });


    if (!items.length) return;


    await fetch('/cart/add.js', {

      method: 'POST',

      headers: {

        'Content-Type':'application/json'

      },

      body: JSON.stringify({

        items: items

      })

    });


    window.location.href = '/cart';


  });


});